import { render, staticRenderFns } from "./PageData.vue?vue&type=template&id=337367c6&"
import script from "./PageData.vue?vue&type=script&lang=js&"
export * from "./PageData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports